import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_BLACKLISTS,
  GET_BLACKLIST_DETAIL,
  ADD_NEW_BLACKLIST,
  UPDATE_BLACKLIST,
} from "./actionTypes"
import {
  getBlacklistsSuccess,
  getBlacklistsFail,
  getBlacklistDetailSuccess,
  getBlacklistDetailFail,
  addBlacklistFail,
  addBlacklistSuccess,
  updateBlacklistSuccess,
  updateBlacklistFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getBlacklists,
  getBlacklistsDetails,
  addNewBlacklist,
  updateBlacklist,
} from "helpers/backend_helper"

function* fetchBlacklists(payload) {
  try {
    console.log('payload', payload);
    const response = yield call(getBlacklists, payload.payload)
    yield put(getBlacklistsSuccess(response))
  } catch (error) {
    yield put(getBlacklistsFail(error))
  }
}

function* fetchBlacklistDetail({ BlacklistId }) {
  try {
    const response = yield call(getBlacklistsDetails, BlacklistId)
    yield put(getBlacklistDetailSuccess(response))
  } catch (error) {
    yield put(getBlacklistDetailFail(error))
  }
}

function* onUpdateBlacklist({ payload: Blacklist }) {
  try {
    const response = yield call(updateBlacklist, Blacklist)
    if (response?.success) {
      yield put(updateBlacklistSuccess(response))
    } else {
      yield put(updateBlacklistFail(response?.message))
    }
  } catch (error) {
    yield put(updateBlacklistFail(error))
  }
}

function* onAddNewBlacklist({ payload: Blacklist }) {
  try {
    const response = yield call(addNewBlacklist, Blacklist)
    if (response?.success) {
      yield put(addBlacklistSuccess(response))
    } else {
      yield put(addBlacklistFail(response?.message||"Failed to add blacklist!"))
    }
  } catch (error) {
    yield put(addBlacklistFail(error))
  }
}

function* BlacklistsSaga() {
  yield takeEvery(GET_BLACKLISTS, fetchBlacklists)
  yield takeEvery(GET_BLACKLIST_DETAIL, fetchBlacklistDetail)
  yield takeEvery(ADD_NEW_BLACKLIST, onAddNewBlacklist)
  yield takeEvery(UPDATE_BLACKLIST, onUpdateBlacklist)
}

export default BlacklistsSaga
